import React, { ReactElement } from 'react'

export interface DragProps {
  children: ReactElement
}

export const Drag: React.FC<DragProps> = ({ children }) => {
  return <div style={{ position: 'relative' }}>{children}</div>
}
